import type { AuthResource } from '@labrav/react-components'
import { RootState } from '../../store'
import { AppScope } from './authorizationModel'

export type { AuthResource }

/**
 * Roles vs scopes vs capabilities
 * - Roles: legacy staff/partner identity roles from `roles.ts` (ADMIN/SUPER_ADMIN/etc).
 * - Scopes: JWT-granted product permissions (cloud/service/operation).
 */

export const selectScopes = (state: RootState): AppScope[] => {
  return state.authorization.scopes
}

export const selectPolicyReady = (state: RootState): boolean =>
  state.authorization.policyLoadStatus === 'ready'

export const selectPolicyLoading = (state: RootState): boolean =>
  state.authorization.policyLoadStatus === 'loading'

export const selectHasScope =
  (scope: AppScope) =>
  (state: RootState): boolean =>
    selectScopes(state).includes(scope)
